<template>
  <v-container fluid>
    <v-card>
      <v-toolbar dense flat color="secondary">
        <v-toolbar-title>Invoice Preview</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn small text to="/pos/daily/sales">
          <v-icon left dark>mdi-keyboard-backspace</v-icon>Back
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <v-row>
          <v-col cols="12" md="12">
            <v-btn text @click="generateInvoice" color="primary">
              <v-icon color="black" left>mdi-file-pdf-box</v-icon>Generate
              Invoice
            </v-btn>

            <v-btn text @click="generateDelivery" color="primary">
              <v-icon color="black" left>mdi-file-pdf-box</v-icon>Generate
              Delivery
            </v-btn>

            
          </v-col>
        </v-row>

        <v-divider></v-divider>



        <v-row class="subtitle-2 text--primary">
          <v-col cols="12" md="4">
            <v-simple-table dense>
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td>Invoice#:</td>
                    <td>{{ Invoice && Invoice.DocNum}}</td>
                  </tr>
                  <tr>
                    <td>Client:</td>
                    <td>{{ Invoice && Invoice.Customer.Name}}</td>
                  </tr>
                  <tr>
                    <td>Total Bill:</td>
                    <td>{{ Invoice && Invoice.DocTotal | currency}}</td>
                  </tr>
                  <tr>
                    <td>Total Paid:</td>
                    <td>{{ Invoice && TotalPaid | currency}}</td>
                  </tr>
                  <tr>
                    <td>Balance:</td>
                    <td>{{ Invoice && Balance | currency}}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>

          <v-col cols="12" offset-md="4" md="4">
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Account</th>
                    <th class="text-left">Amount Paid</th>
                    <th class="text-left">Ref No</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in Payments" v-bind:key="index">
                    <td>{{ item.Account.Name }}</td>
                    <td>{{ item.Amount | currency}}</td>
                    <td>{{ item.PaymentRemarks }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>

        <v-divider></v-divider>

        <v-row dense id="po" class="text--primary subtitle-2 mt-2">
          <v-col cols="12">
            <v-data-table
              dense
              light
              :mobile-breakpoint="0"
              :items-per-page="pageItems"
              :headers="headers"
              :items="SaleRows"
              item-key="id"
              hide-default-footer
            >
              <template v-slot:item.Name="{ item }">
                <span style="width: 200px">{{ item.product.Name }}</span>
              </template>

              <template v-slot:item.Quantity="{ item }">
                {{
                item.Quantity
                }}
              </template>

              <template v-slot:item.Price="{ item }">
                <span v-if="item.Price">{{ item.Price | currency }}</span>
              </template>

              <template v-slot:item.DiscSum="{ item }">
                {{
                item.DiscSum
                }}
              </template>

              <template v-slot:item.LineTotal="{ item }">
                {{
                item.LineTotal | currency
                }}
              </template>
            </v-data-table>
          </v-col>

          <v-col cols="12">
            <span style="font-size: 16px; font-weight: bold">Outsourced Products</span>
            <v-data-table
              light
              :mobile-breakpoint="0"
              :items-per-page="pageItems"
              :headers="outHeaders"
              :items="OutsourcedProducts"
              item-key="id"
              hide-default-footer
            >
              <template v-slot:item.Name="{ item }">
                <span style="width: 200px">{{ item.Name }}</span>
              </template>

              <template v-slot:item.ItemCode="{ item }">
                <span style="width: 200px">{{ item.ItemCode }}</span>
              </template>

              <!-- <template v-slot:item.ref1="{ item }">{{item.ref1}}</template> -->

              <template v-slot:item.Quantity="{ item }">
                {{
                item.Quantity
                }}
              </template>

              <template v-slot:item.Price="{ item }">
                <span v-if="item.Price">{{ item.Price | currency }}</span>
              </template>

              <template v-slot:item.LineTotal="{ item }">
                {{
                item.LineTotal | currency
                }}
              </template>
            </v-data-table>
          </v-col>
        </v-row>

        <!-- snackbar -->
        <snackbar ref="snackbar"></snackbar>
      </v-card-text>
    </v-card>

    <!-- pdf preview -->
    <pdf-preview ref="pdfPreview"></pdf-preview>
    <!-- end -->
  </v-container>
</template>


<script>
import { http, host } from "@/common/index";
export default {
  props: {
    initial: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    record: {},
    loader: false,
    pageItems: 100,
    Invoice: {},
    TotalPaid: 0,
    Balance: 0,
    OutsourcedProducts: [],
    SaleRows: [],
    Payments: [],
    headers: [
      { text: "Item Code", value: "itemCode" },
      { text: "Product", value: "Name" },
      { text: "Qty", value: "Quantity" },
      { text: "Unit", value: "Unit" },
      { text: "Price", value: "Price" },
      { text: "Total", value: "LineTotal" }
    ],
    outHeaders: [
      { text: "Product", value: "Name" },
      { text: "Qty", value: "Quantity" },
      { text: "Unit", value: "Unit" },
      { text: "Price", value: "Price" },
      { text: "Total", value: "LineTotal" }
    ]
  }),
  computed: {
    storeName() {
      return localStorage.getItem("storeName");
    }
  },
  watch: {
    initial: {
      handler: "init",
      immediate: true
    }
  },
  methods: {
    init(val) {
      this.Invoice = val.Invoice;
      this.TotalPaid = val.TotalPaid;
      this.Balance = val.Balance;
      this.SaleRows = val.SaleRows;
      this.OutsourcedProducts = val.OutsourcedProducts;
      this.Payments = val.Payments;
    },
    generateInvoice() {
      var isDistributor = localStorage.getItem("IsDistributor");
      var url = "";
      if(isDistributor == "N") {
        url = "/print-sale-invoice-document/14/" + this.Invoice.id;
      }

      if(isDistributor == "Y") {
        url = "/print-supermarket-invoice-document/14/" + this.Invoice.id;
      }
      
      const apiUrl = `${host}${url}`;
      const self = this;
      http.get(apiUrl, { responseType: "blob" }).then(response => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        var fileUrl = URL.createObjectURL(blob);
        console.log(' invoice file url', fileUrl);
        self.$refs.pdfPreview.show(fileUrl);
      });
    },
    generateDelivery() {
      var isDistributor = localStorage.getItem("IsDistributor");
      var url = "";
      if(isDistributor == "N") {
      url = "/print-supermarket-delivery-document/10/" + this.Invoice.id;
      }

      if(isDistributor == "Y") {
        url = "/print-supermarket-delivery-document/10/" + this.Invoice.id;
      }

      const apiUrl = `${host}${url}`;
      const self = this;
      http.get(apiUrl, { responseType: "blob" }).then(response => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        var fileUrl = URL.createObjectURL(blob);
        self.$refs.pdfPreview.show(fileUrl);
      });
    },
    setDate(date) {
      this.record.DocDate = date;
    }
  },
  created() {

  }
};
</script>

<style  scoped>
/* .v-text-field__details {
  display: none !important;
} */
</style>